import * as React from "react";
export class IncidentItem extends React.PureComponent {
    render() {
        const timePast = this.props.incident.minute > 0 ? `${this.props.incident.minute}${this.props.dict["MinAgo"]}` : this.props.dict["Now"];
        return (React.createElement("li", { className: `rj-incidents-item ${this.props.latestClasses}` },
            React.createElement("div", { className: `rj-incidents-item_badge ${this.props.badgeClass}` },
                React.createElement("span", { className: `icon i-12 ${this.props.iconClass}` })),
            React.createElement("div", { className: "rj-incidents-item_content" },
                React.createElement("span", { className: "rj-incidents-item_time" }, `${this.props.dict[this.props.incident.gamePart]} ${this.props.incident.gameTime}'`),
                React.createElement("span", null, "-"),
                React.createElement("span", { className: "rj-incidents-item_name" }, this.props.dict[this.props.incident.type]),
                React.createElement("span", { className: "rj-incidents-item_team" }, this.props.incident.participant)),
            React.createElement("span", { className: "rj-incidents-item_past" }, timePast)));
    }
}
//# sourceMappingURL=IncidentItem.js.map